var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreenCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836477"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8885 12C12.6527 12 12.4266 12.0937 12.2599 12.2603C12.0932 12.427 11.9996 12.6531 11.9996 12.8889V19.1111H13.7773V13.7778H27.9996V26.2222H22.6662V28H28.8885C29.1242 28 29.3503 27.9064 29.517 27.7397C29.6837 27.573 29.7773 27.3469 29.7773 27.1111V12.8889C29.7773 12.6531 29.6837 12.427 29.517 12.2603C29.3503 12.0937 29.1242 12 28.8885 12H12.8885ZM12.8885 20.8889C12.6527 20.8889 12.4266 20.9825 12.2599 21.1492C12.0932 21.3159 11.9996 21.542 11.9996 21.7778V27.1111C11.9996 27.3469 12.0932 27.573 12.2599 27.7397C12.4266 27.9064 12.6527 28 12.8885 28H19.9996C20.2353 28 20.4614 27.9064 20.6281 27.7397C20.7948 27.573 20.8885 27.3469 20.8885 27.1111V21.7778C20.8885 21.542 20.7948 21.3159 20.6281 21.1492C20.4614 20.9825 20.2353 20.8889 19.9996 20.8889H12.8885ZM13.7773 22.6667H19.1107V26.2222H13.7773V22.6667ZM21.3329 15.5556L23.1489 17.3716L21.1489 19.3716L22.4058 20.6284L24.4058 18.6284L26.2218 20.4444V15.5556H21.3329Z",
    fill: "#63658E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenCircled);
export default __webpack_public_path__ + "static/media/fullScreenCircled.572c8592132777685cfc7f88259a7a0c.svg";
export { ForwardRef as ReactComponent };